module.exports = __webpack_public_path__ + "img/paramount-plus.51e83579.svg";